import {} from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import ShopContextProvider from "./context/ShopContext.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ShopContextProvider>
      <GoogleOAuthProvider clientId="966792273649-9j90l255u7vi0ao37bd6728c0a2r7lmr.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
    </ShopContextProvider>
  </BrowserRouter>
);
